import { Tooltip } from "@jugl-web/ui-components";
import { FC } from "react";
import { ReactComponent as QuestionMarkIcon } from "./assets/question-mark.svg";

interface AppearanceSectionTooltipProps {
  children: React.ReactNode;
}

export const AppearanceTooltip: FC<AppearanceSectionTooltipProps> = ({
  children,
}) => (
  <Tooltip
    placement="bottom"
    className="p-4"
    renderTrigger={({ ref, props }) => (
      <div
        ref={ref}
        {...props}
        className="bg-grey-100 flex h-8 w-8 items-center justify-center rounded-full"
      >
        <QuestionMarkIcon />
      </div>
    )}
  >
    {children}
  </Tooltip>
);
